import React, { useEffect, useRef } from 'react';
import { Chart } from 'chart.js/auto';

export default function UsersGrowthChart({ analytics = [], loading = false }) {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (loading) return;
    if (!analytics || analytics.length === 0) return;

    // destroy previous chart
    if (chartInstance.current) chartInstance.current.destroy();

    const ctx = chartRef.current.getContext('2d');
    chartInstance.current = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: analytics.map((a) => a.year ?? 'Tidak diketahui'),
        datasets: [
          {
            label: 'Akun baru',
            data: analytics.map((a) => a.count_users),
            backgroundColor: 'rgba(13, 110, 253, 0.6)',
            borderRadius: 6,
          },
          {
            label: 'Pendaftaran CLP',
            data: analytics.map((a) => a.count_clp_users),
            backgroundColor: 'rgba(255, 193, 7, 0.6)',
            borderRadius: 6,
          },
        ],
      },
      options: {
        responsive: true,
        animation: { duration: 1200, easing: 'easeOutQuart' },
        scales: { y: { beginAtZero: true } },
      },
    });

    return () => chartInstance.current?.destroy();
  }, [analytics, loading]);

  return (
    <div className="card border-0 shadow-sm rounded-4 mb-4">
      <div className="card-body">
        <h6 className="fw-semibold mb-3">
          <i className="bi bi-bar-chart-line me-2 text-primary" />
          Registrasi Baru per Tahun
        </h6>
        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" />
            <p className="text-muted mt-3 mb-0">Memuat grafik...</p>
          </div>
        ) : analytics.length === 0 ? (
          <p className="text-muted text-center py-4">
            Tidak ada data analytics
          </p>
        ) : (
          <>
            <canvas ref={chartRef} height="120"></canvas>
            <p className="chart-caption">
              <i className="bi bi-lightbulb text-warning me-1"></i>
              Cara baca: tiap batang = registrasi baru pada tahun itu, bukan akumulasi.
            </p>
          </>
        )}
      </div>

      <style>{`
        .chart-caption { font-size: 0.75rem; color: #6c757d; margin: 10px 0 0; }
      `}</style>
    </div>
  );
}
